const preferences = {
  preferenceSettings: {
    nameAlreadyExist: 'Nazwa się powtarza!',
    nameIsEmpty: 'Nie wprowadzono nazwy!',
    notificationPreference: 'Wybierz lokalizacje i odpowiadające im ustawienia preferencji powiadomień',
    option1: 'Chcę otrzymywać powiadomienia zalecane przez Enphase dotyczące wszystkich lokalizacji',
    option2: 'Chcę dostosować moje powiadomienia',
    pageHeader: 'Preferencje',
    title: 'Wybierz opcję powiadomień',
    saveDialogHeader: 'Czy chcesz zapisać zmiany?',
    saveConfirmText: 'Czy chcesz zapisać wprowadzone zmiany?',
    cancelButton: 'Odrzuć',
    saveButton: 'Zapisz',
    defaultDeselectWarning: 'Uwaga! Nie można usuwać lokalizacji z domyślnego zestawu preferencji',
    displayPreferences: 'Preferencje wyświetlania',
    ownSites: 'Własne lokalizacje',
    otherSites: 'Inne lokalizacje',
    emptySites: 'Brak dostępnych lokalizacji!',
    emptyPreferenceSet: 'Brak preferencji!',
    preference: 'Preferencje',
    actions: 'Działania',
    settingsInfo: 'Te ustawienia dotyczą tylko lokalizacji Ensemble',
    selectType: 'Zestawy preferencji',
    selectSite: 'Wybór lokalizacji',
    selectSettings: 'Ustawienia preferencji powiadomień',
    addText: 'Dodaj',
    deleteAlertHeader: 'Potwierdź usunięcie',
    deleteAlertDescription: 'Czy na pewno chcesz trwale usunąć tę preferencję?',
    deleteAlertCancel: 'Anuluj',
    deleteAlertConfirm: 'OK',
    siteEditWarning:
      'Domyślnie Preferencje powiadomień wszystkich posiadanych i innych lokalizacji są ustawione odpowiednio jako „Preferencje domyślne – posiadane” i "Preferencje domyślne – inne".',
    defaultOwnInfo: 'Wszystkie posiadane lokalizacje mają ustawienie "Domyślne preferencje – posiadane"',
    defaultOtherInfo: 'Wszystkie inne lokalizacje mają ustawienie "Domyślne preferencje – inne"',
    defaultInfo: 'Wszystkie lokalizacje mają ustawienie "Domyślne preferencje"',
    createNew: 'Dodaj nowe preferencje',
    siteEditWarningMinimal: 'Domyślnie lokalizacje mają ustawienie „Domyślne preferencje” jako preferencje powiadomień',
    selectAll: 'Zaznacz wszystko',
    generalNotification: 'Powiadomienia ogólne',
    switchToNewPreferencePage: 'PRZEŁĄCZ DO NOWEJ STRONY PREFERENCJI'
  },
  preferences: {
    pageHeader: 'Preferencje',
    title: 'Ustawienia preferencji',
    notificationPreference: 'Preferencje powiadomień',
    activationNotification: 'Wysyłaj mi powiadomienia o aktywacji.',
    monthlySummary: 'Wysyłaj mi comiesięczne podsumowania wydajności systemu.',
    newsletters: 'Wysyłaj mi biuletyny, promocje i ankiety dotyczące produktów lub usług Enphase.',
    newLeadsNotification: 'Powiadamiaj mnie o nowych potencjalnych klientach i zmianach ich statusu',
    alertEmail: 'PREFERENCJE ALERTÓW E-MAIL',
    deviceEventsEmail:
      'Informuj mnie w wiadomości e-mail o zdarzeniach na poziomie urządzenia (wybierz poziom wpływu poniżej)',
    exceptionsAlertEmail: 'Możesz określić wyjątki od preferencji e-maili alertów według systemu.',
    alertPreferences: 'Wyświetl preferencje alertów według systemu',
    saveNotificationPreferences: 'ZAPISZ PREFERENCJE POWIADOMIEŃ',
    displayPreferences: 'Preferencje wyświetlania',
    displayUnits: 'Wyświetl jednostki',
    metric: 'Metryczne',
    imperial: 'Imperialne',
    saveDisplayPreferences: 'ZAPISZ PREFERENCJE WYŚWIETLANIA',
    systemAlert: 'Preferencja alertów systemowych',
    saveChanges: 'Zapisz zmiany',
    label: 'Informuj mnie w wiadomości e-mail o zdarzeniach na poziomie urządzenia (wybierz poziom wpływu poniżej)',
    alertEmailPreference: 'PREFERENCJE ALERTÓW E-MAIL',
    systems: 'Systemy'
  }
};

export default preferences;
